/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import {
  arSummaryData,
  arSummaryFldData,
} from '../../ARSummaryByMfg/store/actions';
import {
  arSummaryQtrData,
  arSummartyByQTRFieldSingle,
} from '../../ARSummaryByQtr/store/actions';
import {
  arSummaryQtrAllData,
  arSummartyByQTRFieldAll,
} from '../../ARSummaryByQtrAll/store/actions';
import {
  arSummaryAllQtrData,
  arSummaryAllTblData,
} from '../../ARSummaryByMfgAll/store/actions';
import {
  fldValueUpdate,
  getUnallocatedMfg,
  manufacturerArTbl,
} from '../../MfgAccountsRec/store/actions';
import {
  DRAMS_QTR_ERR,
  FIRST_SMRY_QTR_ERR,
  commonSearchPageOther,
  commonSearchPage,
} from '../../AccountsRevConstants';
import { removeErr } from '../../../../../SharedModules/utilities/utilities';
import {
  API_TIMEOUT_ERROR,
  FAILED_MESSAGE_GENERIC,
} from '../../../../../SharedModules/Errors/constantMessageData';
import { getAcctRecvAllMfgApiErrorMessage } from '../../apiErrorUtils';

export const errorMsg = (val) => {
  return { type: actiontypes.ACC_ERR_MSG, payload: val };
};

export const resetData = () => {
  return { type: actiontypes.ACC_RESET_STORE };
};

export const setFieldErr = (val) => {
  return { type: actiontypes.ACC_FLD_ERR, payload: val };
};

export const selectedPlan = (val) => {
  return { type: actiontypes.ACC_PLAN_TYPE, payload: val };
};

export const selectedRebatePgm = (val) => {
  return { type: actiontypes.ACC_REBATE_PGM, payload: val };
};

export const selectedURAToUse = (val) => {
  return { type: actiontypes.ACC_URA_TO_USE, payload: val };
};

export const selectedDisplayBy = (val) => {
  return { type: actiontypes.ACC_DISPLAY_BY, payload: val };
};

export const selectedQtrOpt = (val) => {
  return { type: actiontypes.ACC_QTR_OPT, payload: val };
};

export const selectedFromQtr = (val) => {
  return { type: actiontypes.ACC_FROM_QTR, payload: val };
};

export const selectedToQtr = (val) => {
  return { type: actiontypes.ACC_TO_QTR, payload: val };
};

export const updateAllRebate = (val) => {
  return { type: actiontypes.ACC_ALL_REBATE, payload: val };
};

export const allManufacturer = (val) => {
  return { type: actiontypes.ACC_MANU_SELECT, payload: val };
};

export const updateFirstLoad = () => {
  return { type: actiontypes.FIRST_LOAD };
};

export const getPlanTypes = () => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS}`, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch({ type: actiontypes.ACC_PLAN_LIST, payload: response.data });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.ACC_PLAN_LIST, payload: [] });
    });
};

export const getRebateProgram = (planType) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`, { planType: planType })
    .then((response) => {
      let list = [];
      const dropdown = response.data;
      if (dropdown?.status === '001' && dropdown?.message === 'SUCESS') {
        if (!_.isEmpty(dropdown?.data)) {
          list = _.map(dropdown?.data, (val, ind) => {
            return {
              ...val,
              id: val.rebateProgramCd,
              name: val.rebateProgramCd + ' | ' + val.shortDescr,
            };
          });
        }
      }
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      );
      return dispatch({
        type: actiontypes.ACC_REBARE_LIST,
        payload: list,
      });
    })
    .catch((response) => {
      return dispatch({
        type: actiontypes.ACC_REBARE_LIST,
        payload: [],
      });
    });
};

export const storeManufacturesList = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_MANU_LIST_ACC_REC}`, val)
    .then((response) => {
      dispatch({
        type: actiontypes.ACC_MANU_LIST,
        payload: response.data?.mfgVOs,
      });
    })
    .catch((response) =>
      dispatch({ type: actiontypes.ACC_MANU_LIST, payload: [] })
    );
};

export const getMaxQtrFreezeDt = () => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_MAX_QTR_ACC_REC}`, {})
    .then((response) => {
      dispatch({
        type: actiontypes.ACC_END_QTR,
        payload: response.data?.maxQuarter,
      });
    })
    .catch((response) =>
      dispatch({ type: actiontypes.ACC_END_QTR, payload: '' })
    );
};

export const getDramsStartQtr = (val, err) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_DRAMS_QTR_ACC_REC}`, val)
    .then((response) => {
      let value = response.data.dramsInvoiceStartQuarter;
      if (!value) dispatch(errorMsg([...err, DRAMS_QTR_ERR]));
      else {
        let error = removeErr(err, [DRAMS_QTR_ERR]);
        dispatch(errorMsg(error));
      }
      dispatch({ type: actiontypes.ACC_START_QTR, payload: value });
    })
    .catch((response) =>
      dispatch({ type: actiontypes.ACC_START_QTR, payload: '' })
    );
};

export const getSummaryStartQtr = (val, err) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_SMRY_QTR_ACC_REC}`, val)
    .then((response) => {
      let value = response.data.firstSummaryReportQuarter;
      if (!value) dispatch(errorMsg([...err, FIRST_SMRY_QTR_ERR]));
      else {
        let error = removeErr(err, [FIRST_SMRY_QTR_ERR]);
        dispatch(errorMsg(error));
      }
      dispatch({ type: actiontypes.ACC_START_QTR, payload: value });
    })
    .catch((response) =>
      dispatch({ type: actiontypes.ACC_START_QTR, payload: '' })
    );
};

export const getArSummaryAllRpc = (val, data) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_MFG_ALL_ALL}`, val)
    .then((response) => {
      dispatch({
        type: actiontypes.AR_SMRY_FOR_MFG,
        payload: response.data,
      });
      if (data.pgmInfo.indexOf('All') !== -1) {
        dispatch(
          arSummaryAllTblData(
            response.data.acctRecveivableSummaryForAllMfgAllRpc
          )
        );
        dispatch(arSummaryAllQtrData(data));
      } else {
        let arSumData = {
          [val.rebateProgramCode]:
            response.data.acctRecveivableSummaryForAllMfgAllRpc,
        };
        let arSumSingleHeaderData = {
          [val.rebateProgramCode]: data,
        };
        dispatch(arSummaryData(arSumData));
        dispatch(arSummaryFldData(arSumSingleHeaderData));
      }
    })
    .catch((error) => {
      const message = getAcctRecvAllMfgApiErrorMessage(error);
      if (message) {
        dispatch(errorMsg([message]));
      }
      dispatch({ type: actiontypes.AR_SMRY_FOR_MFG, payload: null });
    });
};

export const getArSummaryByQtr = (val, data) => (dispatch, getState) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_QTR_ALL}`, val)
    .then((response) => {
      dispatch({
        type: actiontypes.AR_SMRY_FOR_QTR,
        payload: response.data,
      });

      if (!response.data) {
        dispatch(errorMsg([FAILED_MESSAGE_GENERIC]));
      }

      if (val.rebateProgram === 'All') {
        dispatch(arSummaryQtrAllData(response.data.allQtrsInfo));
        dispatch(arSummartyByQTRFieldAll(data));
      } else {
        let arSumQtrData = {
          [data.pgmCd]: response.data.allQtrsInfo,
        };
        let arSumQtrSingleHeaderData = {
          [data.pgmCd]: data,
        };
        dispatch(arSummaryQtrData(arSumQtrData));
        dispatch(arSummartyByQTRFieldSingle(arSumQtrSingleHeaderData));
      }
    })
    .catch((error) => {
      

      if (
        error.message === 'Network Error' ||
        error.message === 'Request failed with status code 502'
      ) {
        dispatch(errorMsg([API_TIMEOUT_ERROR]));
      }else{
      // Dispatch the error message
      dispatch(errorMsg([FAILED_MESSAGE_GENERIC]));

      // setTimeout(() => {
        // const state = getState();
        // const errors = state.errors || []; // Ensure `errors` is an array
        // dispatch(errorMsg(removeErr(errors, [FAILED_MESSAGE_GENERIC])));
      // }, 10000);
      }

      // Optionally, dispatch a fallback action
      dispatch({ type: actiontypes.AR_SMRY_FOR_QTR, payload: null });
    });
};

export const selectRebateList = () => (dispatch) => {
  let val = ['FD', 'SUPP', 'COMM', 'ST'];
  return axios
    .post(`${serviceEndPoint.GET_SELECT_REBATE_LIST}`, val)
    .then((response) => {
      dispatch({
        type: actiontypes.REBATE_LIST_BY_PLAN,
        payload: response.data.rebateProgramCdVOList,
      });
    })
    .catch((response) =>
      dispatch({ type: actiontypes.REBATE_LIST_BY_PLAN, payload: null })
    );
};

export const getManuARForAllRpc = (val, data) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_MFG_SINGLE_ALL}`, val)
    .then((response) => {
      dispatch({
        type: actiontypes.MFG_AR_ALL_RPC,
        payload: response.data,
      });
      let manuFactuData = {
        [`${data?.mfgId}-${'All'}`]:
          response.data.acctRecvOneMfgAllRpcSummaryResponseVo,
      };
      dispatch(manufacturerArTbl(manuFactuData));
      dispatch(fldValueUpdate({ [`${data?.mfgId}-${'All'}`]: data }));
      let payload = {
        planType: data.planType,
        mfgId: data.mfgId,
        rebateProgram: '',
        startQtr: data.startQtr,
        endQtr: data.endQtr,
        useOfficialURA: data.useOfficialURA,
        allRebateProgIndicator: 1,
      };
      dispatch(getUnallocatedMfg(payload));
    })
    .catch((error) => {
      if (
        error.message === 'Network Error' ||
        error.message === 'Request failed with status code 502'
      ) {
        dispatch(errorMsg([API_TIMEOUT_ERROR]));
      }
      dispatch({ type: actiontypes.MFG_AR_ALL_RPC, payload: null });
    });
};

export const getManuARForSglRpc = (val, data) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_MFG_SINGLE_SIGNLE}`, val)
    .then((response) => {
      dispatch({
        type: actiontypes.MFG_AR_ALL_RPC,
        payload: response.data,
      });
      let payload = {
        planType: data.planType,
        mfgId: data.mfgId,
        rebateProgram: data.rebateProgram,
        startQtr: data.startQtr,
        endQtr: data.endQtr,
        useOfficialURA: data.useOfficialURA,
        allRebateProgIndicator: 0,
      };
      dispatch(getUnallocatedMfg(payload));
      let manuFactuData = {
        [`${data?.mfgId}-${data.rebateProgram}`]:
          response.data.accountReceivableDetailSforSingleMfgGridResponseVOs,
      };
      dispatch(manufacturerArTbl(manuFactuData));
      dispatch(
        fldValueUpdate({ [`${data?.mfgId}-${data.rebateProgram}`]: data })
      );
    })
    .catch((response) =>
      dispatch({ type: actiontypes.MFG_AR_ALL_RPC, payload: null })
    );
};

export const clearReqAccRecSearchPageDispatch = (val) => {
  return { type: actiontypes.CLEAR_REQ_ACC_REC_SEARCH_PAGE, payload: val };
};

export const clearReqAccRecSearchPage = (history) => (dispatch, getState) => {
  const reduxObj = getState()?.sharedState?.AccountRecReducer;
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  let newObj1 = {};
  if (!_.isEmpty(updateTabs)) {
    const newObj = _.cloneDeep(reduxObj);
    if (
      updateTabs.filter(
        (x) => x.navTo === '/mfgAccountRec' || x.navTo === '/ARManufacturer'
      ).length === 0
    ) {
      newObj.rbt_list = [];
    }
    if (
      updateTabs.filter(
        (x) =>
          x.navTo === '/QtrAccountsRecAll' ||
          x.navTo === '/arSummaryByQtrAll' ||
          x.navTo === '/ARSummaryByQtrAll'
      ).length === 0
    ) {
      newObj.rebate_list = [];
    }
    if (
      updateTabs.filter(
        (x) =>
          x.navTo === '/arSummaryByQtrAll' || x.navTo === '/ARSummaryByQtrAll'
      ).length === 0
    ) {
      newObj.rebate_pgm = '';
      newObj.qtr_opt = 'All';
      newObj.end_qtr = '';
      newObj.start_qtr = '';
      newObj.ar_smry_qtr = null;
    }
    newObj1 = _.cloneDeep(newObj);
  } 
  //else {
  //   _.mapKeys(commonSearchPageOther, (val, key) => {
  //     newObj1[key] = val;
  //   });
  //   // newObj1.rebate_list = [];
  //   // newObj1.rbt_list = [];
  //   // newObj1.rebate_pgm = 'MDFD';
  //   // newObj1.qtr_opt = 'All';
  //   // newObj1.end_qtr = '';
  //   // newObj1.start_qtr = '';
  //   // newObj1.ar_smry_qtr = null;
  // }
  _.mapKeys(commonSearchPage, (val, key) => {
    newObj1[key] = val;
  });
  // newObj1.all_rebate = false;
  // newObj1.err_list = [];
  // newObj1.flderror = {};
  // newObj1.plan_type = 'FD';
  // newObj1.ura_to_use = 'Official';
  // newObj1.display_by = 'Manufacturer';
  // newObj1.all_manu = true;
  // newObj1.firstload = true;
  dispatch(clearReqAccRecSearchPageDispatch(newObj1));
};
